// src/components/common/LocationInput.jsx
import React, { useState, useEffect, useRef } from 'react';

const LocationInput = ({ placeholder, value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const autocompleteRef = useRef(null);
  
  // Initialize Google Maps Places Autocomplete when the component mounts
  useEffect(() => {
    // Check if Google Maps API is loaded
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.warn('Google Maps API not loaded. Location input will work as a regular text input.');
      return;
    }
    
    const autocomplete = new window.google.maps.places.Autocomplete(autocompleteRef.current, {
      types: ['address'],
      componentRestrictions: { country: 'in' } // Restrict to India
    });
    
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      
      if (!place.geometry) {
        // User entered the name of a place that was not suggested
        setInputValue(place.name);
        onChange(place.name, null, null);
        return;
      }
      
      // Get the address components
      const address = place.formatted_address;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      
      setInputValue(address);
      onChange(address, lat, lng);
    });
    
    // Clean up
    return () => {
      // No need to clean up Google Maps autocomplete
    };
  }, [onChange]);
  
  // Update local state when prop value changes
  useEffect(() => {
    if (value !== undefined && value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);
  
  // Handle manual input change
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    
    // If the user clears the input, reset everything
    if (!e.target.value) {
      onChange('', null, null);
    }
  };
  
  return (
    <input
      ref={autocompleteRef}
      type="text"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
      placeholder={placeholder}
      value={inputValue}
      onChange={handleInputChange}
      autoComplete="off"
    />
  );
};

export default LocationInput;